import {parse as parseMarkdown} from "@khanacademy/pure-markdown";

export interface TranslationLinterInput {
    /** Context of the translation*/
    context?: string | null | undefined;
    /** Filename of the translation.  No longer used*/
    filename?: string | null | undefined;
    /** Format of the translation.  No longer used.*/
    format?: string | null | undefined;
    /** Original string*/
    msgid: string;
    /** Translated string*/
    msgstr: string;
    /** Markdown-parsed AST of the Original String (json)*/
    parsedMsgid: string;
    /** Markdown-parsed AST of the Translated String (json)*/
    parsedMsgstr: string;
}

// parseTranslationMarkdown will use the exact same Markdown parser that
// we use in Perseus.  The output is a JSONified AST that can be passed up
// to the backend for linting so that the backend isn't responsible for
// transforming the markdown.  This allows the FE and BE to be consistent with
// the markdown parser we use.
function parseTranslationMarkdown(text: string): string {
    return JSON.stringify(parseMarkdown(text));
}

export function createLintTranslationInput(
    source: string,
    translated: string,
    context: string,
    format?: string,
): TranslationLinterInput {
    const parsedMsgid = parseTranslationMarkdown(source);
    const parsedMsgstr = parseTranslationMarkdown(translated);

    return {
        msgid: source,
        msgstr: translated,
        parsedMsgid,
        parsedMsgstr,
        context,
        format,
    };
}
